import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { elementAt, finalize, first } from 'rxjs';
import { AlertService } from 'src/app/services/common/alert.service';
import { ConstantTypeKey, isPartnerPortalUser, productForUserTypes, UserTypeEnum } from 'src/app/services/common/constant.service';
import { UtilityService } from 'src/app/services/utility.service';
import { LoginService } from '../login/login.service';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';
import { IndexedDBService } from 'src/app/services/common/indexedDb.service';
import { TermConditionPageComponent } from 'src/app/shared/widgets/term-condition-page/term-condition-page.component';
import { MatDialog } from '@angular/material/dialog';
import { BusinessUserService } from 'src/app/services/business-user.service';
import { VcardUserService } from 'src/app/services/vcard-user.service';
import { CompanyService } from 'src/app/services/vcard-company.service';

@Component({
  selector: 'app-retailer-Register',
  templateUrl: './retailer-Register.component.html',
  styleUrls: ['./retailer-Register.component.css']
})
export class RetailerRegisterComponent implements OnInit {
  hide = true;
  queryString = Object();
  title: string = "";
  model: any;
  countryCode: any;
  countryList: any[] = [];
  countryFilterList: any[] = [];
  stateList: any[] = [];
  stateFilterList: any[] = [];
  cityList: any[] = [];
  cityFilterList: any[] = [];
  selectedCountryName: any = "";
  userTypeList: any[];
  industryVerticalList: any[];
  typeOfAgencyList: any[];

  submitted = false;
  isSubmitting = false;
  registrationForm: FormGroup = new FormGroup({});

  businessId: string;
  businesslogo: string = "./assets/images/logo-inner.png";

  showBusinessStoreId: boolean = false;

  hidePassword = true;
  hidePasswordConfirm = true;
  referrerType: string[];
  currentTab = "retailer-Register"
  countryName = "default";

  get f() { return this.registrationForm.controls; }
  menuOpen = false;

  priceEmail: string = '';
  priceTelephone: string = '';
  priceAddress: string = '';
  path: string;

  responseForVcard: any;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private loginService: LoginService,
    private utilityService: UtilityService,
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private storageService: StorageService,
    private indexedDbService: IndexedDBService,
    private businessUserService: BusinessUserService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private vcardUserService: VcardUserService,
     private vcardCompService: CompanyService
  ) { }
  buildForm(): void {
    this.registrationForm = this.formBuilder.group({
      userType: [UserTypeEnum.ORGANIZATION, [Validators.required]],
      industryVertical: [''],
      businessStoreId: ['', [
        Validators.pattern(/^[a-zA-Z0-9_-]{0,10}$/)
      ]],
      typeOfAgency: [''],
      firstName: ['', [
        Validators.required,
        this.noOnlySpaces,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(/^(?=.{1,50}$)[A-Za-z]+(?: [A-Za-z]+)*$/)]],
      lastName: ['', [
        this.noOnlySpaces,
        Validators.minLength(2),
        Validators.maxLength(50),
        Validators.pattern(/^(?=.{1,50}$)[A-Za-z]+(?: [A-Za-z]+)*$/)]],
      password: ['', [Validators.required, Validators.pattern(/^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*\d)[A-Za-z\d!@#$%^&*(),.?":{}|<>]{6,}$/)
      ]],
      confirmPassword: ['', [Validators.required]],
      company: ['', [Validators.required,
      Validators.minLength(2),
      this.noOnlySpaces,
      Validators.maxLength(150),
      Validators.pattern(/^(?=.*[A-Za-z])[A-Za-z0-9&.,()\-](?:[A-Za-z0-9&.,()\- ]{0,148}[A-Za-z0-9&.,()\-])?$/)
      ]],
      address: [
        '',
        [
          Validators.required,
          this.noOnlySpaces,
          Validators.minLength(5),
          Validators.maxLength(250),
          Validators.pattern(
            /^(?=.*[A-Za-z])[A-Za-z0-9,.\-\/#() \r\n]{5,250}$/
          )
        ]
      ],
      postalCode: ['', [Validators.required, Validators.minLength(5),
      Validators.maxLength(10), Validators.pattern('^[a-zA-Z0-9]+$')]],
      country: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      // countryCode: ['', [Validators.required]],
      telephone: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(15),
          Validators.pattern(/^[0-9]{8,15}$/) // only digits
        ]
      ],
      termsCondition: [true],

    }, {
      validators: this.passwordMatch.bind(this)
    }
    );
  }
  async ngOnInit() {
    this.logPath();
    this.buildForm();
    this.queryString = this.activatedRoute.snapshot.queryParams;
    //console.log("this.queryString", this.queryString)
    if (this.queryString?.approveToken || this.queryString?.businessId) {
      if (this.queryString.approveToken) {
        var approveToken = this.queryString?.approveToken;
        var decrypt = window.atob(approveToken)
        this.model = JSON.parse(decrypt);
        if (!this.model.email) {
          this.alertService.showError("Invalid link");
          // this.router.navigate(['login']);
        }
      }
      if (this.queryString?.businessId) {
        this.businessId = this.queryString.businessId;

        this.businessUserService.detail_logo(this.businessId).subscribe((res: any) => {
          //console.log("res.data---- username", res.data)
          if (res.success) {
            //console.log("res.data", res.data)
            this.businesslogo = res.data.logo;
            this.referrerType = res.data.userType;
          }
        })
      }
    }
    else if (this.path !== "business-register") {
      this.alertService.showError("Invalid link");
      // this.router.navigate(['login']);
    }
    const countryId = this.registrationForm.getRawValue().country;
    this.setPostalCodeValidation(countryId);
    this.registrationForm.get('country')?.valueChanges.subscribe((countryId: any) => {
      this.setPostalCodeValidation(countryId);
    });
    if (this.model?.email || this.businessId) {
      await this.getConstantList();
      this.countryFilterList = this.countryList = await this.indexedDbService.getCountires();
      //await this.getCountryList();
      this.onChangeUserType();
      this.setDetail();        // values assigned here
      this.disableControl();   // controls may be disabled
      this.initPriceBindings();
    } else if (this.path == "business-register") {
      await this.getConstantList();
      this.countryFilterList = this.countryList = await this.indexedDbService.getCountires();
      //await this.getCountryList();
      this.onChangeUserType();
      this.setDetail();        // values assigned here
      this.disableControl();   // controls may be disabled
      this.initPriceBindings();
    }

  }


  logPath() {
    const rawUrl = this.router.url || '';
    const urlWithoutQuery = rawUrl.split('?')[0];
    const cleanedPath = urlWithoutQuery.replace(/^#\//, '').replace(/^\//, '');
    this.path = cleanedPath;

    this.route.url.subscribe((urlSegments: UrlSegment[]) => {
      const path = urlSegments.map(segment => segment.path).join('/');
      this.path = path;
      if (path == "store-register") {
        this.title = "Register to Redeem Coupons"
      }
      if (path == "business-register" || path == "partner-register") {
        this.title = "Registration Form"
      }
    });

    if (cleanedPath == "store-register") {
      this.title = "Register to Redeem Coupons"
    }
    if (cleanedPath == "business-register" || cleanedPath == "partner-register") {
      this.title = "Registration Form"
    }
  }
  noOnlySpaces(control: any) {
    if (!control.value) return null;

    return control.value.trim().length === 0
      ? { onlySpaces: true }
      : null;
  }

  setPostalCodeValidation(countryId: any) {
    const control = this.registrationForm.get('postalCode');
    if (!control) return;

    const country = this.countryList?.find(
      (c: any) => c.id === countryId
    );

    const isIndia = country?.name === 'India';
    this.selectedCountryName = country?.name || '';

    if (isIndia) {
      control.setValidators([
        Validators.required,
        Validators.pattern(/^[1-9][0-9]{5}$/)
      ]);
    } else {
      control.setValidators([
        Validators.required,
        this.noOnlySpaces,
        Validators.minLength(3),
        Validators.maxLength(10),
        Validators.pattern(/^(?=.{3,10}$)[A-Za-z0-9]+(?:([ ]-[ ]|[ \-])[A-Za-z0-9]+)*$/)
      ]);
    }

    control.updateValueAndValidity();
  }

  getErrorMessage(controlName: string): string {
    const control = this.registrationForm.get(controlName);
    if (!control || !control.errors) return '';

    const errors = control.errors;

    // Handle required
    if (errors.required) return `${this.prettyFieldName(controlName)} is required`;

    // Handle minlength / maxlength
    if (errors.minlength) return `Minimum ${errors.minlength.requiredLength} characters required`;
    if (errors.maxlength) return `Maximum ${errors.maxlength.requiredLength} characters allowed`;

    // Handle pattern
    if (errors.pattern) {
      switch (controlName) {
        case 'businessStoreId':
          return 'Only alphanumeric characters, hyphens and underscores allowed';
        case 'firstName':
        case 'lastName':
          return 'Only alphabets and single space allowed';
        case 'company':
          return 'Must contain at least one alphabet and only allowed characters (& . , - ( ))';
        case 'address':
          return 'Only alphanumeric and , . - / # ( ) characters are allowed';
        case 'postalCode':
          return this.selectedCountryName === 'India'
            ? 'Postal code must be 6 digits'
            : 'Postal code must be 3–10 characters, alphanumeric, space or hyphen allowed';
        case 'email':
          return 'Please enter valid Email ID';
        case 'telephone':
          return 'Only digits allowed (8–15 digits)';
        default:
          return 'Invalid format';
      }
    }

    // Handle custom validator onlySpaces
    if (errors.onlySpaces) return `${this.prettyFieldName(controlName)} cannot be empty or spaces only`;

    return '';
  }

  // Optional: make form control names readable
  prettyFieldName(controlName: string): string {
    switch (controlName) {
      case 'firstName': return 'First name';
      case 'lastName': return 'Last name';
      case 'company': return 'Company name';
      case 'address': return 'Address';
      case 'postalCode': return 'Postal Code';
      case 'email': return 'Email ID';
      case 'telephone': return 'Telephone';
      case 'countryId': return 'Country';
      case 'stateId': return 'State/Province';
      case 'cityId': return 'City';
      default: return controlName;
    }
  }

  trimField(fieldName: string) {
    const control = this.registrationForm.get(fieldName);
    if (control && control.value) {
      control.setValue(control.value.trim(), { emitEvent: false });
    }
  }
  passwordMatch(formGroup: FormGroup) {
    const password = formGroup.get('password');
    const confirmPassword = formGroup.get('confirmPassword');

    const matchingControl = formGroup.controls['confirmPassword'];

    // return if another validator has already found an error on the matchingControl
    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      return;
    }

    // set error on matchingControl if validation fails
    if (password?.value === confirmPassword?.value) {
      matchingControl.setErrors(null);
    }
    else {
      matchingControl.setErrors({ mustMatch: true });
    }
  }

  disableControl() {
    if (this.model?.email) this.f.email.disable();
    if (!this.referrerType) this.f.userType.disable();
    // this.f.company.disable();
    // this.f.countryCode.disable();
    // this.f.country.disable();
    // this.f.state.disable();
    // this.f.city.disable();
    // this.f.telephone.disable();
  }

  private initPriceBindings(): void {
    if (!this.registrationForm) return;

    const emailCtrl = this.registrationForm.get('email');
    const telCtrl = this.registrationForm.get('telephone');
    const addressCtrl = this.registrationForm.get('address');

    if (emailCtrl) {
      this.priceEmail = (emailCtrl.value || '').toLowerCase();
      emailCtrl.valueChanges.subscribe(v => {
        this.priceEmail = (v || '').toLowerCase();
      });
    }

    if (telCtrl) {
      this.priceTelephone = (telCtrl.value || '').toString();
      telCtrl.valueChanges.subscribe(v => {
        this.priceTelephone = (v || '').toString();
      });
    }

    if (addressCtrl) {
      this.priceAddress = (addressCtrl.value || '').toString();
      addressCtrl.valueChanges.subscribe(v => {
        this.priceAddress = (v || '').toString();
      });
    }
  }
  onRegister(formValues: any) {
    // formValues = { email, telephone, address, country }
    // this.registerData.setRegisterData(formValues);
  }

  async getConstantList() {
    await this.utilityService.getConstantList(ConstantTypeKey.IndustryVertical).toPromise().then((response: any) => {
      if (response.success) {
        this.industryVerticalList = response.data;
      }
    })

    await this.utilityService.getConstantList(ConstantTypeKey.UserType).toPromise().then((response: any) => {
      if (response.success) {
        this.userTypeList = response.data.filter((x: { code: string; }) => x.code != UserTypeEnum.ADMIN);
        if (this.referrerType && !this.referrerType.includes(UserTypeEnum.ADMIN)) {
          if (this.referrerType.includes(UserTypeEnum.VP)) this.userTypeList = this.userTypeList.filter(el => ![UserTypeEnum.VP, UserTypeEnum.RETAILER].includes(el.code));
          else if (this.referrerType.includes(UserTypeEnum.DIRECTOR)) this.userTypeList = this.userTypeList.filter(el => ![UserTypeEnum.VP, UserTypeEnum.DIRECTOR, UserTypeEnum.RETAILER].includes(el.code));
          else if (this.referrerType.includes(UserTypeEnum.PARTNER)) this.userTypeList = this.userTypeList.filter(el => ![UserTypeEnum.VP, UserTypeEnum.DIRECTOR, UserTypeEnum.PARTNER, UserTypeEnum.RETAILER].includes(el.code));
          else {
            this.f.userType.setValue(UserTypeEnum.RETAILER);
            this.f.userType.disable();
          }
        }
      }
    })

    await this.utilityService.getConstantList(ConstantTypeKey.AgencyType).toPromise().then((response: any) => {
      if (response.success) {
        this.typeOfAgencyList = response.data;
      }
    })
  }

  async getCountryList() {
    await this.utilityService.getCountryList().toPromise().then((response: any) => {
      if (response.success) {
        this.countryList = response.data;
      }
      else {
        this.countryList = [];
      }
      this.countryFilterList = this.countryList;
    })
  }

  public getStateList(countryId: any) {
    this.utilityService.getStatesList(countryId).subscribe((res: any) => {
      if (res.success) {
        this.stateList = res.data;
      } else {
        this.stateList = [];
      }
      this.stateFilterList = this.stateList;
    })
  }

  onlyNumbers(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  }

  public getCityList(stateId: any) {
    this.utilityService.getCityList(stateId).subscribe((res: any) => {
      if (res.success) {
        this.cityList = res.data;
      } else {
        this.cityList = []
      }
      this.cityFilterList = this.cityList;
    })
  }

  setDetail() {
    if (this.model?.email) {
      this.storageService.setValue(StorageKey.authToken, this.model.adminToken);
      if (this.model && this.model.userType.length >= 1) {
        var type = this.userTypeList.find(x => x.code == this.model.userType)
        if (type) {
          this.f.userType.setValue(type.code);
        }
        else {
          this.f.userType.setValue('');
        }
      } else {
        if (this.model.userType)
          this.f.userType.setValue(this.model.userType.toString());
        else
          this.f.userType.setValue(UserTypeEnum.RETAILER);
      }
      //console.log('data..', this.model)
      //this.f.userType.setValue(this.model?.userType ? this.model?.userType : UserTypeEnum.RETAILER);
      this.f.industryVertical.setValue(this.model?.industryVertical);
      this.f.typeOfAgency.setValue(this.model?.typeOfAgency);
      this.f.firstName.setValue(this.model?.firstName);
      this.f.lastName.setValue(this.model?.lastName);
      this.f.company.setValue(this.model?.company ?? this.model?.firstName);
       if (this.path === 'store-register' && !this.businessId) {
        this.f.firstName.setValue(this.model?.primaryContact);
      }
   
      this.f.address.setValue(this.model?.address);
      this.f.postalCode.setValue(this.model?.postalCode);
      this.f.email.setValue(this.model?.email);
      this.f.country.setValue(this.model?.countryId);
      this.f.telephone.setValue(this.model?.telephone);
      if (this.model?.businessStoreId) {
        this.showBusinessStoreId = true;
        this.f.businessStoreId.setValue(this.model?.businessStoreId);
        this.f.businessStoreId.disable();
      }
      else {
        this.f.businessStoreId.setValue('');
        this.showBusinessStoreId = false;
      }
      //console.log('countryList', this.countryList)
      var country = this.countryList.find(x => x.id == this.model?.countryId);
      if (country) {
        this.countryCode = country.code;
      } else {
        this.countryCode = "";
      }

      if (this.model?.countryId)
        this.countryFilterList = this.countryList.filter(x => x.id == this.model?.countryId);

      if (this.model?.countryId) {
        this.utilityService.getStatesList(this.model?.countryId).subscribe((resState: any) => {
          if (resState.success) {
            this.stateList = resState.data;
            this.f.state.setValue(this.model.stateId);
          } else {
            this.stateList = [];
          }
          if (this.model.stateId)
            this.stateFilterList = this.stateList.filter(x => x.id == this.model.stateId);
          if (this.model?.stateId) {
            this.utilityService.getCityList(this.model.stateId).subscribe((rescity: any) => {
              if (rescity.success) {
                this.cityList = rescity.data;
                this.f.city.setValue(this.model.cityId);
              }
              else {
                this.cityList = [];
              }
              if (this.model.cityId)
                this.cityFilterList = this.cityList.filter(x => x.id == this.model.cityId);
            })
          }
        })
      }
    }
    else {
      setTimeout(() => {
        this.f.businessStoreId.setValue('');
        this.f.password.setValue('');
        this.showBusinessStoreId = true;
      }, 100);
    }
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.hidePasswordConfirm = !this.hidePasswordConfirm;
  }

  onChangeUserType() {
    if (this.f.userType.value == "AGEN") {
      this.registrationForm.controls["typeOfAgency"].setValidators(Validators.required);
      this.registrationForm.controls["industryVertical"].clearValidators();
      this.f.typeOfAgency.enable();
      this.f.industryVertical.disable();
      this.f.industryVertical.setValue('');
    }
    else {
      this.registrationForm.controls["typeOfAgency"].clearValidators();
      this.registrationForm.controls["industryVertical"].setValidators(Validators.required);
      this.f.typeOfAgency.disable();
      this.f.industryVertical.enable();
      this.f.typeOfAgency.setValue('');
    }
    this.registrationForm.controls['industryVertical'].updateValueAndValidity();
    this.registrationForm.controls['typeOfAgency'].updateValueAndValidity();
  }

  onChangeCountry(event: any) {
    this.countryFilterList = this.countryList.filter(x => (x.name.toLowerCase()).includes(event.toLowerCase()));
    if (event) {
      let country = this.countryList.find(x => x.id == event)
      if (country) {
        this.countryCode = country.code;
        // this.f1.countryCode.setValue(country.code);
        this.stateList = [];
        this.cityList = [];
        this.f.state.setValue('');
        this.f.city.setValue('');
        this.getStateList(event);
        this.countryName = country.name;
      }
      else {
        this.countryCode = "";
        // this.f1.countryCode.setValue('');
        this.stateList = [];
        this.cityList = [];
        this.f.state.setValue('');
        this.f.city.setValue('');
      }
    }
    else {
      this.countryCode = "";
      // this.f1.countryCode.setValue('');
      this.f.state.setValue('');
      this.f.city.setValue('');
      this.stateList = [];
      this.cityList = [];
    }
  }

  displayFnCountry = (id: string): string => {
    const country = this.countryList?.find(el => el.id == id) ?? {};
    return country.name;
  }

  onChangeState(event: any) {
    this.stateFilterList = this.stateList?.filter(x => (x.name.toLowerCase()).includes(event.toLowerCase()));
    this.f.city.setValue('');
    if (event) {
      let state = this.stateList.find(x => x.id == event);
      if (state) {
        this.getCityList(event);
      } else {
        this.cityList = [];
      }
    } else {
      this.cityList = [];
    }
  }

  displayFnState = (id: string): string => {
    const state = this.stateList?.find(el => el.id == id) ?? {};
    return state.name;
  }

  onChangeCity(event: any) {
    this.cityFilterList = this.cityList?.filter(x => (x.name.toLowerCase()).includes(event.toLowerCase()));
  }

  displayFnCity = (id: string): string => {
    const city = this.cityList?.find(el => el.id == id) ?? {};
    return city.name;
  }

  onSubmit() {
    if (this.isSubmitting) return;

    this.submitted = true;
    if (this.registrationForm.invalid)
      return;

    let isValidForm = true;
    if (this.f.country.value) {
      let country = this.countryList.find(x => x.id == this.f.country.value);
      if (!country) {
        isValidForm = false;
        this.countryCode = "";
        this.f.country.setValue('');
      }
    }

    if (this.f.state.value) {
      let state = this.stateList.find(x => x.id == this.f.state.value);
      if (!state) {
        isValidForm = false;
        this.f.state.setValue('');
      }
    }

    if (this.f.city.value) {
      let city = this.cityList.find(x => x.id == this.f.city.value);
      if (!city) {
        isValidForm = false;
        this.f.city.setValue('');
      }
    }


    if (isValidForm) {
      this.isSubmitting = true;
      var model = Object.assign({});
      model.registration_source = productForUserTypes(this.f.userType.value);
      const isPartnerRegistration = this.path === 'partner-register' && !!this.businessId;

      if (this.f.userType.value == UserTypeEnum.RETAILER || isPartnerRegistration || isPartnerPortalUser(this.referrerType)) {
        model.industryVertical = this.f.industryVertical.value;
        model.typeOfAgency = "";
        model.firstName = this.f.firstName.value;
        model.lastName = this.f.lastName.value;
        model.company = this.f.company.value;
        model.address = this.f.address.value;
        model.countryId = this.f.country.value;
        model.stateId = this.f.state.value;
        model.cityId = this.f.city.value;
        model.telephone = this.f.telephone.value;
        model.password = this.f.password.value;
        if (this.businessId) {
          model.email = this.f.email.value;
          model.postalCode = this.f.postalCode.value;
          model.primaryContact = this.f.firstName.value;
          model.businessStoreId = this.f.businessStoreId.value;
          if (this.f.userType.value == UserTypeEnum.RETAILER)
            this.loginService.businesss_store_registration(this.businessId, model).pipe(
              first(),
              finalize(() => this.isSubmitting = false)
            ).subscribe({
              next: (response: any) => {
                if (response.success) {
                  this.storageService.removeValue(StorageKey.authToken);
                  this.responseForVcard = response;
                  this.registrationAlyro(this.responseForVcard, this.f);
                  const modelOTP = {
                    id: response.data,
                    businessId: this.businessId,
                    email: this.f.email.value
                  };

                  const encodedID = window.btoa(JSON.stringify(modelOTP));
                  this.router.navigate(['otp-validate'], { queryParams: { ID: encodedID } });
                }
              }
            });
          else {
            model.userType = this.f.userType.value;
            this.loginService.partner_registration(this.businessId, model).pipe(
              first(),
              finalize(() => this.isSubmitting = false)
            ).subscribe({
              next: (response: any) => {
                if (response.success) {
                  this.storageService.removeValue(StorageKey.authToken);
                  const modelOTP = {
                    id: response.data,
                    businessId: this.businessId,
                    email: this.f.email.value
                  };

                  const encodedID = window.btoa(JSON.stringify(modelOTP));
                  this.router.navigate(['otp-validate'], { queryParams: { ID: encodedID } });
                }
              }
            });
          }
        } else {
          this.loginService.registration_approve(this.model._id ?? this.model.id, this.model.businessId, model).pipe(
            first(),
            finalize(() => this.isSubmitting = false)
          ).subscribe({
            next: (response: any) => {
              if (response.success) {
                this.responseForVcard = response;
                this.registrationAlyro(this.responseForVcard, this.f, false);
                //this.alertService.showSuccess("Sign Up succesfully");
                this.storageService.removeValue(StorageKey.authToken);
                this.router.navigate(['login']);
              }
            }
          });
        }
      }


      else if (this.f.userType.value == UserTypeEnum.ORGANIZATION || this.f.userType.value == UserTypeEnum.ORGANIZATION_CATALOG || this.f.userType.value == UserTypeEnum.ORGANIZATION_LITE || this.f.userType.value == UserTypeEnum.BASE_ORGANIZATION || this.f.userType.value == UserTypeEnum.PARTNER || this.f.userType.value == UserTypeEnum.VP || this.f.userType.value == UserTypeEnum.DIRECTOR) {
        model.industryVertical = this.f.industryVertical.value;
        model.typeOfAgency = this.f.typeOfAgency.value;
        model.firstName = this.f.firstName.value;
        model.lastName = this.f.lastName.value;
        model.company = this.f.company.value;
        model.address = this.f.address.value;
        model.countryId = this.f.country.value;
        model.stateId = this.f.state.value;
        model.cityId = this.f.city.value;
        model.telephone = this.f.telephone.value;
        model.password = this.f.password.value;
        if (this.model?._id || this.model?.id) {
          this.loginService.registration_approve(this.model._id ?? this.model.id, this.model.id, model).pipe(
            first(),
            finalize(() => this.isSubmitting = false)
          ).subscribe({
            next: (response: any) => {
              if (response.success) {
                this.responseForVcard = response;
                this.registrationAlyro(this.responseForVcard, this.f, false);
                this.storageService.removeValue(StorageKey.authToken);
                this.router.navigate(['login']);
              }
            }
          });
        } else {
          model.email = this.f.email.value;
          model.postalCode = this.f.postalCode.value;
          model.primaryContact = this.f.firstName.value;
          model.userType = UserTypeEnum.ORGANIZATION;
          this.loginService.business_registration(model).pipe(
            first(),
            finalize(() => this.isSubmitting = false)
          ).subscribe({
            next: (response: any) => {
              if (response.success) {
                this.responseForVcard = response;
                this.storageService.removeValue(StorageKey.authToken);
                this.registrationAlyro(this.responseForVcard, this.f);
                const modelOTP = {
                  id: response.data,
                  businessId: this.businessId,
                  email: this.f.email.value
                };

                const encodedID = window.btoa(JSON.stringify(modelOTP));
                this.router.navigate(['otp-validate'], { queryParams: { ID: encodedID } });
              }
            }
          });
        }
      }
      else {
        this.isSubmitting = false;
      }

     
    }
  }

  // registrationAlyro(response:any,model:any) {
  registrationAlyro(response:any,model:any, redirectToVcard: boolean = true) {
      //setup variables value for the vcard
      const vcardPayload = {
        "email":  model.email.value,
        "password": model.password.value,
        "firstName": model.firstName.value,
        "lastName": model.lastName.value,
        "mobile": model.telephone.value,
        "address": model.city.value + "," + model.state.value + "," + model.country.value,
        "ownerId": response?.data ?? this.model?._id ?? this.model?.id,
        // "ownerId": response.data,
        "maxUsers": 1
      };

      console.log(`response: ${JSON.stringify(response)}`);
      console.log(`payload: ${vcardPayload}`);
      //end setup variables value for the vcard


      //code set for vcard
               
      //first registratio in alyro then approve full registration part
      this.vcardCompService.addVcardRegistration(vcardPayload).subscribe({
        next: (resCr:any) => {
          if(resCr.success) {
            //success
            this.alertService.showSuccess(resCr.message);

              const vcardToken = localStorage.getItem('vcardToken');

              // if (!vcardToken) {
              if (!vcardToken && redirectToVcard) {
                var vcardLogin: any = {
                  "email": vcardPayload.email.trim(),
                }
                this.vcardUserService.generateToken(vcardLogin).subscribe((restok:any) => {
                  if(restok.token) {
                    sessionStorage.setItem('vcardUser', JSON.stringify({ token: restok.token, userInfo: restok.user }));
                    localStorage.setItem('vcardToken', restok.token);
                      localStorage.setItem('vcardUser', JSON.stringify(restok.user));
                  }
                    this.router.navigate(['admin/vcard-contact']);
                });
                    
              
              }
                
          } else {
            this.alertService.showError(`Fail to add new user in Alyro Application`);
          }
        },
        error: (error) => {
            console.log(error);
            // this.alertService.showError(error?.message);
        }
          
      });
          
       
     
      
      //end code set for vcard
  }
  onClickBack() {
    this.router.navigate(['login']);
  }

  onClickTermCondition() {
    let dialogRef = this.dialog.open(TermConditionPageComponent, {
      disableClose: true,
      width: '50%',
    });
    dialogRef.afterClosed().subscribe(result => {
      this.f.termsCondition.setValue(true);
    });
  }
  changeTab(tab: any) {
    this.currentTab = tab
  }

}